/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { LoadingSpinner } from "../Interface";

import { useOverlayContainerSelector } from "./Container";
import { OverlayStateProvider } from "./OverlayStateContext";

import "./Overlay.scss";

export const Overlay = () => {
  const container = useOverlayContainerSelector();

  return (
    <div className="PlayerOverlay">
      <div className="PlayerOverlay__LoadingLayer">
        <LoadingSpinner />
      </div>
      <div className="PlayerOverlay__ContentLayer">
        <OverlayStateProvider>{container}</OverlayStateProvider>
      </div>
    </div>
  );
};
